
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './index.scss';
import InfiniteScroll from 'react-infinite-scroller';
import { costReq } from '@/store/actions'
import { setTopBar } from '@/utils/jrSdk'
import { GetRequest } from '@/utils';
import ComTag from '@/components/comTag';
function Cost() {
    const [channelCode, setChannelCode] = useState(GetRequest('channelCode'));
    const [taskCode, setTaskCode] = useState(GetRequest('taskCode'));
    const [hasMore, SetHasMore] = useState(true);
    const { list, pageNo, end } = useSelector(state => state.cost);
    const dispatch = useDispatch();
    useEffect(() => {
        setTopBar({title: '消费详情', bg: '#ffffff'})
        getMore();
    }, [])
    function getMore() {
        if(end) return ;
        dispatch(costReq({ channelCode: channelCode, taskCode: taskCode, pageNo}));
    }
    return (
        <div className='cost-list'>
            {list && list.length?<InfiniteScroll
                pageStart={0}
                loadMore={getMore}
                hasMore={hasMore}
                loader=''
            >
                {
                    list.map((it, idx) => <Item info={it} key={idx} />)
                }
            </InfiniteScroll>: 
            list && 
            list.length === 0 &&
            end === true ?
            <div className='cost-no'>暂无数据~</div> :
            <div className='cost-no'>加载中</div>
            }
            {
                end && list && list.length?<ComTag title='京东金融'></ComTag>: null
            }
        </div>
    )
}

const Item = React.memo(function ({
    info
}) {
    return (
        <div className='cost-item-box'>
            <div className='cost-box-left'>
                <div className='cost-left-title'>{info.orderDesc}</div>
                <div className='cost-left-order'>订单编号: {info.orderNo}</div>
                <div className='cost-left-time'>{info.time}</div>
            </div>
            <div className='cost-box-right'>
                <div className='cost-right-price'>{info.price}</div>
            </div>
        </div>
    )
})

export default React.memo(Cost);